// IMPORTANTE IMPORTAR A DEPENDÊNCIA NO ARQUIVO INDEX.JS
import React, { createContext, useState } from "react";

export const TitleContext = createContext()

export const TitleContextProvider = ({children}) => {
    const [title, setTitle] = useState('')

    return (
        <TitleContext.Provider value={{ title, setTitle}}>
            {children}
        </TitleContext.Provider>
    )
}